import { Link, useLocation } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import AuthContext from '../AuthContextComponent/AuthContext';
import logo from "../../Assets/img/techno_logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import AuthenticationService from "../../Services/AuthenticationService";
import Dropdown from 'react-bootstrap/Dropdown';
import Logo from '../../Assets/img/Navig.png';
import DeviceWhite from '../../Assets/img/Devices-white-icon.png'
import PartnerWhite from '../../Assets/img/Partners-white-icon.png'
import InfoWhite from '../../Assets/img/Info-white-icon.png'
import HelpWhite from '../../Assets/img/Help-white-icon.png'
import CertificatesWhite from '../../Assets/img/Certificates-white-icon.png'
import ConfigurationWhite from '../../Assets/img/Configurations-white-icon.png'
import CountriesWhite from '../../Assets/img/Countries-white-icon.png'
import UsersWhite from '../../Assets/img/Users-white-icon.png'
import UserRoleWhite from '../../Assets/img/User-roles-white-icon.png'
import DeviceModelWhite from '../../Assets/img/Device-models-white-icon.png'
import { ReactComponent as HelpIcon } from '../../Assets/img/Helpicon.svg';
import { ReactComponent as AboutIcon } from '../../Assets/img/Infoicon.svg';
import { ReactComponent as Certificate } from '../../Assets/img/Certificates.svg';
import { ReactComponent as Configuration } from '../../Assets/img/Configurationblack.svg';
import { ReactComponent as Countries } from '../../Assets/img/Countries.svg';
import { ReactComponent as Devicemodel } from '../../Assets/img/Device-models.svg';
import { ReactComponent as Device } from '../../Assets/img/Devices.svg';
import { ReactComponent as Partner } from '../../Assets/img/Partners.svg';
import { ReactComponent as Userrole } from '../../Assets/img/User-roles.svg';
import { ReactComponent as User } from '../../Assets/img/Users.svg';
import { ReactComponent as LogoutIcon } from '../../Assets/img/Logout-icon.svg';
import { ReactComponent as LogoutHoverIcon } from '../../Assets/img/Logout-hover-icon.svg';
import { ReactComponent as ProfileSettingsIcon } from '../../Assets/img/Profile-settings-icon.svg';
import { ReactComponent as ProfileSettingsHoverIcon } from '../../Assets/img/Profile-settings-hover-icon.svg';
import { ReactComponent as Idmfingerprinticon } from '../../Assets/img/Idm-finger-print-icon.svg';
import { ReactComponent as ProfileIcon } from '../../Assets/img/Profile-icon.svg';

function Navigation() {
    const authCtx = useContext(AuthContext);
    const isLoggedIn = authCtx.isLoggedIn;
    const isTenantSelected = authCtx.isTenantSelected;
    const role = authCtx.role;
    const [open, setOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        authCtx.selectPage(location.pathname.substring(1));

    }, [])
    const logoutHandler = () => {
        authCtx.logout();
        AuthenticationService.logout()
            .then(() => {
            })
            .catch((err) => {
            })
    };

    const activeHandler = (index) => {
        document.querySelectorAll('.sidebar-row').forEach((el) => {
            el.classList.remove("active");
        })
        document.querySelectorAll('.sidebar-row').item(index).classList.add("active");
    }

    return (
        <div className="sidebar">
            <img src={Logo} className="sidebar-logo" alt="fireSpot" />
            <div className="finger-image"> <Idmfingerprinticon /></div>
            <div className="list-container">
                {isTenantSelected && <ul className="sidebar-sidebarList">
                    <li className="sidebar-row_head">
                        <div id="sidebar-icon"></div>
                        <div id="sidebar-title">Tenant Management</div>
                    </li>
                    <li className={'sidebar-row ' + (authCtx.selectedPageName == "Devices" ? 'active' : "")} onClick={() => authCtx.selectPage("Devices")}>
                        <Link className={`nav-link link`} to="/Devices">
                            <div id="sidebar-icon" >
                                {(authCtx.selectedPageName == "Devices" ? <img src={DeviceWhite} alt="fireSpot" /> : <Device />)}
                            </div>
                            <div id="sidebar-title">Devices</div>
                        </Link>
                    </li>
                    {/* <li className={'sidebar-row ' + (authCtx.selectedPageName == "Configurations" ? 'active' : "")} onClick={() => authCtx.selectPage("Configurations")}>
                        <Link className={`nav-link link`} to="/Configurations">
                            <div id="sidebar-icon">
                                {(authCtx.selectedPageName == "Configurations" ? <img src={ConfigurationWhite} className="sidebar-icon whiteicon" alt="fireSpot" /> : <Configuration />)}
                            </div>
                            <div id="sidebar-title">Configurations</div>
                        </Link>
                    </li> */}
                    <li className={'sidebar-row ' + (authCtx.selectedPageName == "Device-Models" ? 'active' : "")} onClick={() => authCtx.selectPage("Device-Models")}>
                        <Link className={`nav-link link`} to="/Device-Models">
                            <div id="sidebar-icon">
                                {(authCtx.selectedPageName == "Device-Models" ? <img src={DeviceModelWhite} className="sidebar-icon whiteicon" alt="fireSpot" /> : <Devicemodel />)}
                            </div>
                            <div id="sidebar-title">Device Models</div>
                        </Link>
                    </li>
                    {role == "Partner" && <li className={'sidebar-row ' + (authCtx.selectedPageName == "Certificates" ? 'active' : "")} onClick={() => authCtx.selectPage("Certificates")}>
                        <Link className={`nav-link link`} to="/Certificates">
                            <div id="sidebar-icon">
                                {(authCtx.selectedPageName == "Certificates" ? <img src={CertificatesWhite} className="sidebar-icon whiteicon" alt="fireSpot" /> : <Certificate />)}
                            </div>
                            <div id="sidebar-title">Certificates</div>
                        </Link>
                    </li>}
                    {/* <li className={'sidebar-row ' + (authCtx.selectedPageName == "TenantUsers" ? 'active' : "")} onClick={() => authCtx.selectPage("TenantUsers")}>
                        <Link className={`nav-link link`} to="/About">
                            <div id="sidebar-icon">
                                {(authCtx.selectedPageName == "TenantUsers" ? <img src={UsersWhite} className="sidebar-icon whiteicon" alt="fireSpot" /> : <User />)}
                            </div>
                            <div id="sidebar-title">Users</div>
                        </Link>
                    </li> */}
                </ul>}
                <div>
                    {authCtx.role == "Admin" && <ul className="sidebar-sidebarList">
                        <li className="sidebar-row_head">
                            <div id="sidebar-icon"></div>
                            <div id="sidebar-title">Administration</div>
                        </li>
                        <li className={'sidebar-row ' + (authCtx.selectedPageName == "Partners" ? 'active' : "")} onClick={() => authCtx.selectPage("Partners")}>
                            <Link className={`nav-link link`} to="/Partners">
                                <div id="sidebar-icon">
                                    {(authCtx.selectedPageName == "Partners" ? <img src={PartnerWhite} className="sidebar-icon whiteicon" alt="fireSpot" /> : <Partner />)}
                                </div>
                                <div id="sidebar-title">Partners</div>
                            </Link>
                        </li>
                        <li className={'sidebar-row ' + (authCtx.selectedPageName == "IdaCertificate" ? 'active' : "")} onClick={() => authCtx.selectPage("IdaCertificate")}>
                            <Link className={`nav-link link`} to="/IdaCertificate">
                                <div id="sidebar-icon">
                                    {(authCtx.selectedPageName == "IdaCertificate" ? <img src={CertificatesWhite} className="sidebar-icon whiteicon" alt="fireSpot" /> : <Certificate />)}
                                </div>
                                <div id="sidebar-title">IDA Certificate</div>
                            </Link>
                        </li>
                        {/* <li className={'sidebar-row ' + (authCtx.selectedPageName == "Countries" ? 'active' : "")} onClick={() => authCtx.selectPage("Countries")}>
                            <Link className={`nav-link link`} to="/About">
                                <div id="sidebar-icon">
                                    {(authCtx.selectedPageName == "Countries" ? <img src={CountriesWhite} className="sidebar-icon whiteicon" alt="fireSpot" /> : <Countries />)}
                                </div>
                                <div id="sidebar-title">Countries</div>
                            </Link>
                        </li> */}
                        <li className={'sidebar-row ' + (authCtx.selectedPageName == "Users" ? 'active' : "")} onClick={() => authCtx.selectPage("Users")}>
                            <Link className={`nav-link link`} to="/Users">
                                <div id="sidebar-icon">
                                    {(authCtx.selectedPageName == "Users" ? <img src={UsersWhite} className="sidebar-icon whiteicon" alt="fireSpot" /> : <User />)}
                                </div>
                                <div id="sidebar-title">Users</div>
                            </Link>
                        </li>
                    </ul>}
                </div>
                <ul className="sidebar-sidebarList">
                    <li className="sidebar-row_head">
                        <div id="sidebar-icon"></div>
                        <div id="sidebar-title">Other</div>
                    </li>
                    <li className={'sidebar-row sidebar-row-bottom ' + (authCtx.selectedPageName == "About" ? 'active' : "")} onClick={() => authCtx.selectPage("About")}>
                        <Link className={`nav-link link bottom`} to="/About">
                            <div id="sidebar-icon">
                                {(authCtx.selectedPageName == "About" ? <img src={InfoWhite} className="sidebar-icon whiteicon" alt="fireSpot" /> : <AboutIcon />)}
                            </div>
                            <div id="sidebar-title">About</div>
                        </Link>
                    </li>
                    <li className={'sidebar-row sidebar-row-bottom ' + (authCtx.selectedPageName == "Help" ? 'active' : "")} onClick={() => authCtx.selectPage("Help")}>
                        <Link className={`nav-link link bottom`} to="/Help">
                            <div id="sidebar-icon">
                                {(authCtx.selectedPageName == "Help" ? <img src={HelpWhite} className="sidebar-icon whiteicon" alt="fireSpot" /> : <HelpIcon />)}
                            </div>
                            <div id="sidebar-title">Help</div>
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="sidebar-footercontainer">
                <div className="sidebar-profilepersonicon" ><ProfileIcon /></div>
                <span style={{ marginLeft: "5%" }}>{authCtx.selectedUserName}</span>
                <div className="sidebar-profilecontainer">
                    <span className="logout-icon-container sidebar-profileicon">
                        <ProfileSettingsIcon className="logout-icon" />
                        <ProfileSettingsHoverIcon className="logout-icon logout-hover-icon" onClick={() => setOpen(!open)} />
                    </span>
                    {open &&
                        <div className="sidebar-dropup-container">
                            <Link to="/Change-password" className="sidebar-dropup-content" onClick={() => {
                                authCtx.selectPage("Change-password");
                                setOpen(false);
                            }}>Change Password</Link>
                        </div>
                    }
                    <span className="logout-icon-container">
                        <LogoutIcon className="logout-icon" />
                        <LogoutHoverIcon className="logout-icon logout-hover-icon" onClick={logoutHandler} />
                    </span>
                </div>
            </div>
        </div>
    );
}

export default Navigation;
